interface VersionResponse {
    hash: string;
    wasm?: string;
}

export function useVersionCheck() {
    const clientHash = (window as Record<string, unknown>).__BUILD_HASH__ as string | undefined;
    const clientWasmHash = (window as Record<string, unknown>).__WASM_HASH__ as string | undefined;

    const fetchVersion = async (): Promise<VersionResponse | null> => {
        try {
            const response = await fetch('/build/version.json', { cache: 'no-store' });
            if (!response.ok) return null;
            return (await response.json()) as VersionResponse;
        } catch {
            return null;
        }
    };

    const hasNewVersion = async (): Promise<boolean> => {
        if (!clientHash) return false;
        const data = await fetchVersion();
        return data !== null && data.hash !== clientHash;
    };

    const hasNewWasm = async (): Promise<boolean> => {
        if (!clientWasmHash || clientWasmHash === 'dev') return false;
        const data = await fetchVersion();
        return data !== null && data.wasm !== undefined && data.wasm !== clientWasmHash;
    };

    return { hasNewVersion, hasNewWasm };
}
